import PropTypes from 'prop-types';

const PaginationUser = ({
  currentPage,
  totalUsers,
  usersPerPage,
  handlePreviousPage,
  handleNextPage,
  paginate,
}) => {
  const totalPages = Math.ceil(totalUsers / usersPerPage);

  // Function to generate page numbers with ellipsis
  const getPageNumbers = () => {
    const delta = 1; // Number of pages to show before and after current page
    const pages = [];
    
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 || // First page
        i === totalPages || // Last page
        (i >= currentPage - delta && i <= currentPage + delta) // Pages around current
      ) {
        pages.push(i);
      } else if (pages[pages.length - 1] !== '...') {
        pages.push('...');
      }
    }
    
    return pages;
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between items-center gap-4 px-2">
      {/* Info text */}
      <div className="text-sm text-gray-600 order-2 sm:order-1">
        <span className="hidden sm:inline">
          Showing {(currentPage - 1) * usersPerPage + 1} to{" "}
          {Math.min(currentPage * usersPerPage, totalUsers)} of {totalUsers} entries
        </span>
        <span className="sm:hidden">
          {(currentPage - 1) * usersPerPage + 1}-{Math.min(currentPage * usersPerPage, totalUsers)}/{totalUsers}
        </span>
      </div>

      {/* Pagination buttons */}
      <div className="flex gap-1 sm:gap-2 order-1 sm:order-2">
        <button
          className="btn btn-sm sm:btn-md min-w-[36px] sm:min-w-[44px]"
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
        >
          <i className="fas fa-chevron-left sm:hidden"></i>
          <span className="hidden sm:inline">Previous</span>
        </button>

        {getPageNumbers().map((page, index) => (
          page === '...' ? (
            <button key={`ellipsis-${index}`} className="btn btn-sm sm:btn-md" disabled>
              ...
            </button>
          ) : (
            <button
              key={page}
              className={`btn btn-sm sm:btn-md ${
                currentPage === page ? "btn-active btn-outline" : ""
              }`}
              onClick={() => paginate(page)}
            >
              {page}
            </button>
          )
        ))}

        <button
          className="btn btn-sm sm:btn-md"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          <i className="fas fa-chevron-right sm:hidden"></i>
          <span className="hidden sm:inline">Next</span>
        </button>
      </div>
    </div>
  );
};

PaginationUser.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalUsers: PropTypes.number.isRequired,
  usersPerPage: PropTypes.number.isRequired,
  handlePreviousPage: PropTypes.func.isRequired,
  handleNextPage: PropTypes.func.isRequired,
  paginate: PropTypes.func.isRequired,
};

export default PaginationUser;